import { render, staticRenderFns } from "./AddClinicDownloadFileModal.vue?vue&type=template&id=73623e8d&scoped=true"
import script from "./AddClinicDownloadFileModal.vue?vue&type=script&lang=js"
export * from "./AddClinicDownloadFileModal.vue?vue&type=script&lang=js"
import style0 from "./AddClinicDownloadFileModal.vue?vue&type=style&index=0&id=73623e8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73623e8d",
  null
  
)

export default component.exports